import React from "react";
import styles from "./PrimaryBuyers.module.sass";
import Row from "./row";

const PrimaryBuyers = ({ item }) => {
	return (
		<div className={styles.wrapper}>
			<div className={styles.table}>
				<div className={styles.row}>
					<div className={styles.col}>Name</div>
					<div className={styles.col}>Email</div>
					<div className={styles.col}>Date</div>
				</div>
				{item.bids.map((e) => (
					<Row item={e} key={e._id} />
				))}
			</div>
		</div>
	);
};

export default PrimaryBuyers;
